import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    id: 1,
    eyebrow: "品牌核心亮点",
    title: "十二年沉淀，只为把一件事做可靠",
    description:
      "从一间小工作室到覆盖全国的品牌，想要XX 始终坚持把复杂留给自己，把简单交给用户。",
    to: "/brand/b1",
    cta: "了解品牌历程",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20abstract%20brand%20hero%20background%20with%20soft%20blue%20gray%20gradient%20and%20subtle%20orange%20light%20streaks%2C%20clean%20minimal%20geometric%20shapes%2C%20cinematic%20soft%20lighting%2C%20premium%20editorial%20style&width=1920&height=1080&seq=hero-brand-01&orientation=landscape",
  },
  {
    id: 2,
    eyebrow: "最新重要新闻",
    title: "新一代品牌服务框架正式发布",
    description:
      "围绕更开放、更一致、更易用三个方向重构，合作伙伴可通过统一入口接入品牌核心能力。",
    to: "/news/n1",
    cta: "查看新闻详情",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20launch%20hero%20background%20with%20glowing%20horizontal%20panel%20in%20blue%20gray%20and%20a%20warm%20orange%20accent%20line%2C%20dark%20soft%20gradient%2C%20minimal%20technology%20editorial%20graphic&width=1920&height=1080&seq=hero-news-01&orientation=landscape",
  },
  {
    id: 3,
    eyebrow: "资源查询推荐",
    title: "2026 品牌白皮书现已开放查阅",
    description:
      "系统梳理品牌定位、视觉语言与传播方法论，为品牌与市场从业者提供权威参考资料。",
    to: "/resources/r1",
    cta: "前往资源查询",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20resource%20hero%20background%20with%20layered%20soft%20paper%20panels%20in%20blue%20gray%20and%20a%20single%20orange%20edge%2C%20clean%20studio%20lighting%2C%20editorial%20abstract%20composition&width=1920&height=1080&seq=hero-resource-01&orientation=landscape",
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const active = slides[current];

  return (
    <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            idx === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/65 to-primary-900/35" />
        </div>
      ))}

      <div className="relative z-10 flex h-full w-full items-center px-4 md:px-8">
        <div className="w-full max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/95 px-4 py-1.5 text-xs font-semibold text-background-50">
            <i className="ri-flashlight-fill text-sm" />
            {active.eyebrow}
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-background-50">
            {active.title}
          </h1>
          <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-background-200">
            {active.description}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to={active.to}
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
            >
              {active.cta}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/brand"
              className="inline-flex items-center gap-2 rounded-md border border-background-200/60 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap"
            >
              浏览品牌介绍
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
        {slides.map((slide, idx) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => setCurrent(idx)}
            aria-label={`切换到第 ${idx + 1} 张`}
            className={`h-1.5 rounded-full transition-all ${
              idx === current ? "w-8 bg-accent-500" : "w-3 bg-background-200/60"
            }`}
          />
        ))}
      </div>
    </section>
  );
}